var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCta = function SvgCta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cta_svg__a)",
    d: "M4 1h72a3 3 0 0 1 3 3v52c0 12.703-10.297 23-23 23H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F5AC9",
    strokeWidth: 2,
    d: "M4 1h72a3 3 0 0 1 3 3v52c0 12.703-10.297 23-23 23H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cta_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#cta_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cta_svg__d)",
    d: "M37 40.885 33.115 37 31 39.115l6 6 12-12L46.885 31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cta_svg__e)",
    d: "m40 61-9.264-4.94A16.47 16.47 0 0 1 22 41.5V22a3.003 3.003 0 0 1 3-3h30a3.003 3.003 0 0 1 3 3v19.5a16.47 16.47 0 0 1-8.736 14.56zM25 22v19.5a13.48 13.48 0 0 0 7.148 11.914L40 57.6l7.852-4.187A13.48 13.48 0 0 0 55 41.5V22z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cta_svg__a",
    x1: 40,
    x2: 40,
    y1: 0,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3381F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F5AC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cta_svg__d",
    x1: 40,
    x2: 40,
    y1: 19,
    y2: 61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cta_svg__e",
    x1: 40,
    x2: 40,
    y1: 19,
    y2: 61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cta_svg__b",
    width: 52,
    height: 52,
    x: 14,
    y: 15,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_486_10"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_486_10",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cta_svg__c",
    width: 40,
    height: 46,
    x: 20,
    y: 18,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_486_10"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_486_10",
    result: "shape"
  })))));
};
export default SvgCta;